import {
  actionCartSlice,
  actionsSlice as actionsOldSlice,
  applautReviewsSlice,
  compareSlice,
  filterSlice,
  headerSlice,
  homeSlice,
  modalSlice,
  productManagementSlice,
  sezonnoeKhranenieSlice,
  shmSlice,
  shopSlice,
  shopsSlice,
  staticPageSlice,
} from './slices';

import { kladerApi } from './api';

import { combineReducers } from 'redux';

import { actionsSlice, actionApi } from '@app/entities/Actions';
import { bannerSlice } from '@app/entities/BannerPage';
import { brandSlice } from '@app/entities/Brand';
import { deliverySlice } from '@app/entities/Delivery';
import { infoMessageSlice } from '@app/entities/infoMessages';
import { newsSlice } from '@app/entities/News';
import { paymentSlice } from '@app/entities/Payment';
import { questionsSlice } from '@app/entities/Questions';
import { userSlice, apiUser } from '@app/entities/User';
import { wishlistProductSlice } from '@app/entities/Wishlist/module/slice/wishlistProductSlice';
import { geoSlice } from '@app/features/getGeolocation';
import { subscriptionApi } from '@app/features/subscription';
import { analoguesProductSlice, productSlice } from '@entities/Product';
import { availabilityProductSlice, storesByServiceSlice } from '@entities/Shop';
import { productAvailabilityInTheStoresApi } from '@features/productAvailabilityInTheStores';

// TODO новые entities страница discount переделать стейт

import { authSlice } from '@entities/Auth';
import { autoApi, fitsTheAutoSlice, autoUserSlice, autoParamsSlice } from '@entities/Auto';
import { basketSlice } from '@entities/Basket';
import { discountSlice } from '@entities/Discount';
import { orderSlice, userOrdersSlice } from '@entities/Order';
import { storageSlice } from '@entities/Storage';
import { serviceSlice } from '@entities/Services';
import { warrantyUserSlice } from '@entities/Warranty';
import { fastOrderSlice } from '@features/fastOrder';
import { filterSlice as newFilterSlice } from '@entities/Filter';
import { catalogApi, catalogSlice } from '@entities/Catalog';
import { seoSlice, seoApi } from '@entities/Seo';

export const reducers = {
  [apiUser.reducerPath]: apiUser.reducer,
  [autoApi.reducerPath]: autoApi.reducer,
  [catalogApi.reducerPath]: catalogApi.reducer,
  [actionApi.reducerPath]: actionApi.reducer,
  [seoApi.reducerPath]: seoApi.reducer,
  [kladerApi.reducerPath]: kladerApi.reducer,
  [subscriptionApi.reducerPath]: subscriptionApi.reducer,
  [productAvailabilityInTheStoresApi.reducerPath]: productAvailabilityInTheStoresApi.reducer,

  [bannerSlice.name]: bannerSlice.reducer,
  [fitsTheAutoSlice.name]: fitsTheAutoSlice.reducer,
  [autoUserSlice.name]: autoUserSlice.reducer,
  [geoSlice.name]: geoSlice.reducer,
  [basketSlice.name]: basketSlice.reducer,
  [shopSlice.name]: shopSlice.reducer,
  [shopsSlice.name]: shopsSlice.reducer,
  [compareSlice.name]: compareSlice.reducer,
  [actionsOldSlice.name]: actionsOldSlice.reducer,
  [actionCartSlice.name]: actionCartSlice.reducer,
  [filterSlice.name]: filterSlice.reducer,
  [applautReviewsSlice.name]: applautReviewsSlice.reducer,
  [shmSlice.name]: shmSlice.reducer,
  [sezonnoeKhranenieSlice.name]: sezonnoeKhranenieSlice.reducer,
  [discountSlice.name]: discountSlice.reducer,
  [staticPageSlice.name]: staticPageSlice.reducer,

  [homeSlice.name]: homeSlice.reducer,
  [headerSlice.name]: headerSlice.reducer,
  [modalSlice.name]: modalSlice.reducer,
  [productManagementSlice.name]: productManagementSlice.reducer,

  [brandSlice.name]: brandSlice.reducer,
  [actionsSlice.name]: actionsSlice.reducer,
  [infoMessageSlice.name]: infoMessageSlice.reducer,
  [deliverySlice.name]: deliverySlice.reducer,
  [paymentSlice.name]: paymentSlice.reducer,
  [productSlice.name]: productSlice.reducer,
  [availabilityProductSlice.name]: availabilityProductSlice.reducer,
  [storesByServiceSlice.name]: storesByServiceSlice.reducer,
  [analoguesProductSlice.name]: analoguesProductSlice.reducer,
  [questionsSlice.name]: questionsSlice.reducer,
  [wishlistProductSlice.name]: wishlistProductSlice.reducer,
  [newsSlice.name]: newsSlice.reducer,
  [userSlice.name]: userSlice.reducer,
  [authSlice.name]: authSlice.reducer,
  [orderSlice.name]: orderSlice.reducer,
  [userOrdersSlice.name]: userOrdersSlice.reducer,
  [warrantyUserSlice.name]: warrantyUserSlice.reducer,
  [storageSlice.name]: storageSlice.reducer,
  [fastOrderSlice.name]: fastOrderSlice.reducer,
  [newFilterSlice.name]: newFilterSlice.reducer,
  [catalogSlice.name]: catalogSlice.reducer,
  [seoSlice.name]: seoSlice.reducer,
  [serviceSlice.name]: serviceSlice.reducer,
  [autoParamsSlice.name]: autoParamsSlice.reducer,
};

export function createReducerManager(initialReducers) {
  const reducers = { ...initialReducers };
  let combinedReducer = combineReducers(reducers);
  let keysToRemove = [];
  return {
    getReducerMap: () => reducers,

    reduce: (state, action) => {
      if (keysToRemove.length > 0) {
        state = { ...state };
        for (const key of keysToRemove) {
          delete state[key];
        }
        keysToRemove = [];
      }

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return combinedReducer(state, action);
    },

    add: (key, reducer) => {
      if (!key || reducers[key]) {
        return;
      }

      reducers[key] = reducer;

      combinedReducer = combineReducers(reducers);
    },

    remove: key => {
      if (!key || !reducers[key]) {
        return;
      }

      delete reducers[key];

      keysToRemove.push(key);

      combinedReducer = combineReducers(reducers);
    },
  };
}
